// 3rd-party modules
import * as yup from 'yup';
import { message } from 'antd';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';

// project modules
import Button from '../../components/shared/button';
import Input from '../../components/shared/inputs/input';
import Loader from '../../components/shared/loader';
import { apiCall } from '../../helpers/apiHelper';
import { trimStringProps } from '../../helpers/objectHelper';

// apis
import * as AuthApi from '../../apis/authApi';

// models
import { ApiResponse } from '../../models/response';

type FormValues = {
  email: string;
};

const schema = yup.object().shape({
  email: yup.string().label("Email").max(250).email().required()
});

export default function ForgotPasswordPage() {
  const { control, handleSubmit, setValue, setFocus } = useForm<FormValues | any>({
    resolver: yupResolver(schema)
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const abortController = new AbortController();

  useEffect(() => {
    const email = searchParams.get("email");
    if (email) {
      setValue("email", email);
    }
    setFocus("email");
  }, []);

  const onSubmit = async (formData: FormValues) => {
    setLoading(true);
    let response: ApiResponse = await apiCall(AuthApi.forgotPassword(trimStringProps(formData), abortController.signal));
    setLoading(false);

    if (response.success) {
      message.success("Your Email sent successfully.");

    } else
      message.error(response.error?.value);
  };

  const onBackToLoginClick = () => {
    navigate({
      pathname: "/auth/login",
    });
  };

  return (
    <>
      {loading && <Loader />}
      <view data-border="none">
        <section data-position="center">
          <wrapper>
            <group data-space-horizontal="10">
              <group data-direction="column" data-gap="10">
                <text
                  data-weight="800"
                  data-text-size="xx-large"
                  data-wrap="wrap"
                >
                  Forgot Password
                </text>
                <text data-text-size="large" data-wrap="wrap">
                  Use your Kibosh Account Email
                </text>
              </group>
              <group
                data-gap="10"
                data-direction="column"
                data-space-vertical="50"
                data-max-length="300">
                <Input
                  control={control}
                  name="email"
                  label="Email"
                  dataLength="320"
                  size="large" />
                <space></space>
                <Button
                  large
                  primary
                  text="Forgot Password"
                  onClick={handleSubmit(onSubmit)} />
                <Button
                  fit
                  large
                  outline
                  text="Back To Login" onClick={onBackToLoginClick} />
              </group>
            </group>
          </wrapper>
        </section>
      </view>
    </>
  );
}
